import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b3cf28c2&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=b3cf28c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3cf28c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b3cf28c2')) {
      api.createRecord('b3cf28c2', component.options)
    } else {
      api.reload('b3cf28c2', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=b3cf28c2&scoped=true&", function () {
      api.rerender('b3cf28c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/references/vacation-types/index.vue"
export default component.exports